module.exports = __webpack_public_path__ + "static/1.4_1440x540_Desktop_Hero_1X-756541081f90e128a314e52567fd565a.png";